<template>
  <component
    :is="getWrapperTag"
    ref="wrapperElementRef"
    v-bind="getWrapperAttributes"
    :style="getWrapperInlineStyle"
    :id="`wrapper-${element.id}`"
    :class="[
      {
        'form-wrapper-element': !isPreview,
        'wrapper-hover': getIsWrapperHoverActive,
        'show-drop-zone': isShowDropZone,
        'is-empty': !getWrappedElements.length,
      },
      getWrapperAttributeClass,
    ]"
    @dragover.prevent="handleDragOver"
    @dragleave="handleDragLeave"
    @drop="handleDrop"
    @mouseenter="onWrapperMouseHandler(true)"
    @mouseleave="onWrapperMouseHandler(false)"
  >
    <div
      v-if="!isPreview"
      class="d-flex align-items-center justify-content-between"
      :data-drag-handle="`label-${element.id}`"
    >
      <FormLabel :element="element" :labelStyle="labelStyle" />
      <FormElementTools
        v-if="!isPreview && !dragItemId && !isAskAiModalVisible"
        :element="element"
        :isActivePropsElement="isActivePropsElement"
        :isAbsolute="false"
        @removeElement="onRemoveElement"
        @duplicateElement="onDuplicateElement"
        @insertNewElement="onInsertNewElement"
      />
    </div>

    <FormBuilderElement
      v-for="(element, index) in getWrappedElements"
      :key="element.id"
      :element="element"
      :elements="elements"
      :isPreview="isPreview"
      :brandedStyle="brandedStyle"
      :idx="index"
      :isActivePropsElement="isActivePropsElement"
      :draggable="draggable"
      :dragItemId="dragItemId"
      :tabStructure="tabStructure"
      :tabData="tabData"
      :rowIndex="rowIndex"
      :colIndex="colIndex"
      :tabIndex="tabIndex"
      :isDragInsideGrid="isDragInsideGrid"
      :isAskAiModalVisible="isAskAiModalVisible"
      :toggleListState="toggleListState"
      :layoutSetting="layoutSetting"
      :formSettings="formSettings"
      :brandedSubmitBtnStyle="brandedSubmitBtnStyle"
      @editElement="onElementEdit"
      :dragPosition="getDragPostion(index)"
      @dragstart="onElementDragStart($event, element)"
      @dragover="onElementDragOver($event, index, element)"
      @drop="onElementDrop($event, element.id)"
      @dragend="onDragEnd"
      @dragleave="onElementDragLeave($event, element)"
      @removeElement="onRemoveElement"
      @duplicateElement="onDuplicateElement"
      @insertNewElement="onInsertNewElement"
      @setDragItemId="setDragItemId"
      @mouseenter="onElementMouseHandler(true)"
      @mouseleave="onElementMouseHandler(false)"
      @onToggleListStateChange="onToggleListStateChange"
      @tabButtonSubmit="(event) => $emit('tabButtonSubmit', event)"
    />
  </component>
</template>
<script>
import {
  moveElementInTabStructure,
  removeDragItemImage,
  setDragItemImage,
  findElementInTab,
} from '@/utils/helpers/FormBuilderHelper';
import FormLabel from '@/components/FormBuilder/core/FormLabel.vue';
import FormElementTools from '@/components/FormBuilder/core/FormElementTools.vue';
export default {
  name: 'FormWrapperElement',
  props: {
    element: {
      type: Object,
      required: true,
    },
    elements: {
      type: Array,
      required: true,
    },
    dragItemId: {
      type: Number,
      default: null,
    },
    tabStructure: {
      type: Object,
      default: () => ({}),
      required: true,
    },
    tabData: {
      type: Object,
      default: () => ({}),
      required: true,
    },
    rowIndex: {
      type: [Number, String],
      required: true,
    },
    colIndex: {
      type: [Number, String],
      required: true,
    },
    tabIndex: {
      type: [Number, String],
      required: true,
    },
    isDragInsideGrid: {
      type: Boolean,
      default: () => false,
    },
    isAskAiModalVisible: {
      type: Boolean,
      default: false,
    },
    draggable: {
      type: Boolean,
      default: false,
    },
    isActivePropsElement: {
      type: Function,
      default: () => false,
    },
    isPreview: {
      type: Boolean,
      default: false,
    },
    brandedStyle: {
      type: Object,
      default: () => {},
    },
    labelStyle: {
      type: Object,
      default: () => {},
    },
    layoutSetting: {
      type: Object,
      default: () => ({}),
    },
    formSettings: {
      type: Object,
      default: () => ({}),
    },
    brandedSubmitBtnStyle: {
      type: Object,
      default: () => ({}),
    },
    toggleListState: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      dragOverIndex: null,
      dragPosition: null,
      isElementHovered: false,
      isWrapperHovered: false,
      isAllowToDropOuterItem: false,
    };
  },
  methods: {
    onElementDragStart(event, element) {
      if (this.isPreview || !this.draggable) return;
      event.stopPropagation();
      this.setDragItemId(element.id);
      setDragItemImage(event);
    },
    handleDragOver(event) {
      if (
        this.dragOverIndex !== null ||
        this.isPreview ||
        !this.dragItemId ||
        this.dragItemId === this.element.id ||
        (this.getWrappedDragItemIndex && this.getWrappedDragItemIndex !== -1) ||
        !this.isDropAllowed(this.element.id)
      )
        return;

      if (this.getWrappedElements.length) {
        const lastWrappedElement =
          this.getWrappedElements[this.getWrappedElements.length - 1];
        if (lastWrappedElement && lastWrappedElement.id === this.dragItemId) {
          this.isAllowToDropOuterItem = false;
          return;
        }
      }
      event.dataTransfer.dropEffect = 'move';
      const bounds = event.currentTarget.getBoundingClientRect();
      const mouseY = event.clientY;
      const offsetTop = Math.round(mouseY - bounds.top);
      const height = bounds.height;
      this.isAllowToDropOuterItem = offsetTop >= 27 && offsetTop <= height - 2;
    },
    onElementDragOver(event, index, element) {
      if (this.isPreview || !this.dragItemId || !this.draggable) return;
      this.dragOverIndex = index;
      const bounds = event.currentTarget.getBoundingClientRect();
      const mouseY = event.clientY;
      const offsetTop = Math.round(mouseY - bounds.top);
      const height = bounds.height;

      // if (
      //   // this.isAllowToDropOuterItem ||
      //   (offsetTop >= 27 + 15 &&
      //     offsetTop <= height - 17 &&
      //     element.type === 'togglelist')
      // ) {
      if (
        this.isAllowToDropOuterItem ||
        (offsetTop >= 27 + 15 &&
          offsetTop <= height - 17 &&
          ['wrapper', 'togglelist'].includes(element.type))
      ) {
        this.dragPosition = null;
        return;
      }
      const position = offsetTop <= height * 0.5 ? 'top' : 'bottom';
      if (
        !this.isDropAllowed(element.id, position) ||
        (this.getWrappedDragItemIndex !== -1 &&
          (index === this.getWrappedDragItemIndex ||
            (position === 'bottom' &&
              index === this.getWrappedDragItemIndex - 1) ||
            (position === 'top' && index === this.getWrappedDragItemIndex + 1)))
      ) {
        this.dragPosition = null;
      } else {
        this.dragPosition = position;
      }
    },
    onElementDrop(event, elementId) {
      if (
        this.isPreview ||
        !this.dragItemId ||
        !this.dragPosition ||
        !this.draggable
      )
        return;
      event.stopPropagation();
      const updatedTabList = moveElementInTabStructure({
        data: this.tabStructure.tabs,
        dragId: this.dragItemId,
        dropId: elementId,
        position: this.dragPosition,
        rowIndex: this.rowIndex,
        colIndex: this.colIndex,
        dropTabIndex: this.tabIndex,
        isDragInsideGrid: this.isDragInsideGrid,
      });
      if (updatedTabList) this.$set(this.tabStructure, 'tabs', updatedTabList);
      this.setDragItemId(null);
      this.onDragEnd();
      this.$emit('dragend');
    },
    handleDrop(event) {
      if (this.isPreview || !this.draggable || !this.isAllowToDropOuterItem)
        return;
      event.stopPropagation();

      if (!this.dragItemId || this.dragItemId === this.element.id)
        return this.setDragItemId(null);
      const updatedTabList = moveElementInTabStructure({
        data: this.tabStructure.tabs,
        dragId: this.dragItemId,
        dropId: this.element.id,
        rowIndex: this.rowIndex,
        colIndex: this.colIndex,
        dropTabIndex: this.tabIndex,
        isDragInsideGrid: this.isDragInsideGrid,
      });
      if (updatedTabList) this.$set(this.tabStructure, 'tabs', updatedTabList);
      this.setDragItemId(null);
      this.onDragEnd();
      this.$emit('dragend');
    },
    onElementDragLeave(event, element) {
      event.stopPropagation();
      if (this.getWrappedElements.length) {
        const firstWrappedElement = this.getWrappedElements[0];

        const srcElement = event.srcElement;
        const fromElement = event.fromElement;
        const isDraggingOut =
          fromElement?.closest('.form-wrapper-element') !==
          this.$refs.wrapperElementRef;

        if (
          isDraggingOut ||
          (firstWrappedElement &&
            firstWrappedElement.id === element.id &&
            srcElement?.classList?.contains('form-field') &&
            !(
              srcElement?.classList?.contains('form-field') &&
              fromElement?.classList?.contains('form-field') &&
              fromElement.id != srcElement.id
            ) &&
            !event.target.contains(event.fromElement))
        ) {
          this.onDragEnd();
        }
      }
    },
    onDragEnd() {
      this.dragOverIndex = null;
      this.dragPosition = null;
      this.isAllowToDropOuterItem = false;
      removeDragItemImage();
    },
    setDragItemId(id) {
      this.$emit('setDragItemId', id);
    },
    isDropAllowed(elementId, position = null) {
      return (
        this.dragItemId &&
        moveElementInTabStructure({
          data: this.tabStructure.tabs,
          dragId: this.dragItemId,
          dropId: elementId,
          position: position,
          checkIsAllow: true,
          rowIndex: this.rowIndex,
          colIndex: this.colIndex,
          dropTabIndex: this.tabIndex,
          isDragInsideGrid: this.isDragInsideGrid,
        })
      );
    },
    handleDragLeave() {
      this.onDragEnd();
    },
    onElementEdit(element) {
      if (!this.isPreview) this.$emit('editElement', element || this.element);
    },
    getDragPostion(index) {
      return this.dragOverIndex === index ? this.dragPosition : null;
    },
    onRemoveElement(element) {
      this.$emit('removeElement', element);
    },
    onDuplicateElement(element) {
      this.$emit('duplicateElement', element);
    },
    onInsertNewElement(elementId, position) {
      this.$emit('insertNewElement', elementId, position);
    },
    onWrapperMouseHandler(bool) {
      this.isWrapperHovered = bool;
    },
    onElementMouseHandler(bool) {
      this.isElementHovered = bool;
    },
    onToggleListStateChange(elementId, isOpen) {
      this.$emit('onToggleListStateChange', elementId, isOpen);
    },
  },
  computed: {
    getWrapperTag() {
      return this.element?.settings?.tag || 'div';
    },
    isShowDropZone() {
      return (
        !this.isPreview &&
        this.isAllowToDropOuterItem &&
        !this.getWrappedElements.length &&
        this.isDropAllowed(this.element.id)
      );
    },
    getWrappedElements() {
      const tab = this.tabStructure.tabs[this.tabIndex];
      const WrappedElement = findElementInTab(tab, this.element.id);
      return (WrappedElement?.childs || []).map((child) =>
        this.elements.find((element) => element.id === child.elementId)
      );
    },
    getWrappedDragItemIndex() {
      const elements = this.getWrappedElements;
      return elements.findIndex((el) => el.id === this.dragItemId);
    },
    getIsWrapperHoverActive() {
      return (
        (this.isWrapperHovered && !this.isElementHovered) ||
        this.isActivePropsElement(this.element)
      );
    },
    getWrapperAttributePayload() {
      const attr = this.element?.settings?.attributes || [];
      return attr.reduce(
        (acc, { key, value }) => {
          if (key && value && key.trim() !== '' && value.trim() !== '') {
            const normalizedKey = key.trim();
            if (normalizedKey.toLowerCase() === 'class') {
              acc.classes.push(value.trim());
            } else if (normalizedKey.toLowerCase() === 'style') {
              acc.styles.push(value.trim());
            } else {
              acc.attrs[normalizedKey] = value;
            }
          }
          return acc;
        },
        { attrs: {}, classes: [], styles: [] }
      );
    },
    getWrapperAttributes() {
      return this.getWrapperAttributePayload.attrs;
    },
    getWrapperAttributeClass() {
      return this.getWrapperAttributePayload.classes
        .filter((cls) => cls.length)
        .join(' ');
    },
    getWrapperInlineStyle() {
      const inlineStyle = this.getWrapperAttributePayload.styles
        .filter((style) => style.length)
        .join('; ');
      return inlineStyle || null;
    },
  },
  components: {
    FormBuilderElement: () => import('../FormBuilderElement.vue'),
    FormLabel,
    FormElementTools,
  },
};
</script>
<style scoped>
.form-wrapper-element {
  border: 0.7px solid #dddddd !important;
  border-radius: 10px !important;
  padding: 10px !important;
  display: flex;
  flex-direction: column;
  position: relative;
}

.form-wrapper-element.wrapper-hover {
  background: #ededed82 !important;
}

.form-wrapper-element.wrapper-hover .edit-mode-tool-wrapper {
  display: flex;
}

.form-wrapper-element .form-field-card {
  background: white;
  border-radius: 10px;
}

.form-wrapper-element .form-label {
  margin-bottom: 0 !important;
}

.form-wrapper-element.show-drop-zone::after {
  content: '';
  position: absolute;
  left: 12px;
  right: 12px;
  height: 30px;
  bottom: 12px;
  background-color: #86c3f4;
  opacity: 0.5;
  pointer-events: none;
}

.form-wrapper-element.is-empty {
  min-height: 85px;
}
</style>
